import __request__ from "routing/request";
export function all() {
  return __request__("GET", "/events/entity_types", null, {}, {
    "Accept": ["application/json"]
  });
}
